module.exports = __webpack_public_path__ + "img/goods7_5.a3524e6e.jpg";